// START_MODULE components_atoms_icons_arrowleft_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';

import { IconProps } from './interfaces/iconProps';

const ArrowLeft: React.FC<IconProps> = ({ size = 24, color = 'currentColor', ...restProps }) => (
  <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" xmlns="http://www.w3.org/2000/svg" {...restProps}>
    <path d="M6.5 12H18.5M6.5 12L11.5 7M6.5 12L11.5 17" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ArrowLeft;

// END_MODULE components_atoms_icons_arrowleft_tsx
